import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRenrenComponent } from './simple-icons-renren.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRenrenComponent ],
    exports:      [ SimpleIconsRenrenComponent ],
    bootstrap:    []
})
export class SimpleIconsRenrenModule {}
